<template>
  <div>
    <div class="v-table__overflow">
      <table class="v-datatable v-table theme--light">
        <slot></slot>
      </table>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
